import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { getGenders } from "../../actions/left-menu-actions/actions";
import { SelectGender } from "../Header/SelectGender";

interface Props {
  handleChangeOrder: (x: any) => void;
  handleChange2: (x: any, y: any) => void;
  state: any;
  fetchUser: any;
  collaborators: any;
  handleCollabChange: any;
  handleChangeGender: (x: any) => void;
}

export const AddOrderBottomDrawer = ({
  handleChangeOrder,
  handleChange2,
  state,
  fetchUser,
  collaborators,
  handleCollabChange,
  handleChangeGender,
}: Props) => {
  const [allGenders, setAllGenders] = React.useState<any>(null);
  const leftMenu = useSelector((state: any) => state.leftMenu);
  const dispatch = useDispatch();
  React.useEffect(() => {
    if (leftMenu.allGenders.data) {
      setAllGenders(
        leftMenu.allGenders.data.map((el: any) => {
          return {
            label: el.name,
            value: el.id,
          };
        })
      );
    }
  }, [leftMenu.allGenders]);

  React.useEffect(() => {
    dispatch(getGenders());
  }, []);

  return (
    <div style={{ width: "80%" }} className="container-fluid">
      <p className="text-center add_order_drawer_subtitle">
        Enter your order's information
      </p>
      <div className="row">
        <div className="form_add_article_left col-md-6 col-12">
          <div className="row">
            <div className="col-12 mb-4">
              <div className="field field_article field_article_name">
                <input
                  type="text"
                  name="name"
                  id="orderName"
                  placeholder="     "
                  onChange={(e: any) => handleChangeOrder(e)}
                />
                <label htmlFor="orderName" className="folder_label">
                  Name Your Order
                </label>
              </div>
            </div>
            <div className="col-12 mb-md-5">
              <div className="field">
                <SelectGender
                  allGenders={allGenders}
                  handleChangeGender={handleChangeGender}
                />
              </div>
            </div>
            <div className="col-12 mb-4 mt-4">
              <div className="field field_article">
                <Select
                  isMulti
                  name="colors"
                  placeholder="Select your collaborators"
                  options={
                    collaborators &&
                    collaborators.map((el: any) => {
                      return {
                        label: el.name,
                        value: el.id,
                      };
                    })
                  }
                  className="basic-multi-select"
                  classNamePrefix="select"
                  onChange={handleCollabChange}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="form_add_article_left col-md-6 col-12">
          <div className="row">
            <div className="col-12 mb-4">
              <div className="field">
                <input
                  type="text"
                  name="season"
                  id="order_season"
                  onChange={(e: any) => handleChangeOrder(e)}
                  placeholder=" "
                />
                <label htmlFor="order_season" className="login_email_label">
                  Season
                </label>
              </div>
            </div>
            <div className="col-12 mb-4 field field_article">
              <textarea
                name="details"
                id="details"
                placeholder="  "
                onChange={(e: any) => handleChangeOrder(e)}
                rows={6}
              ></textarea>
              <label htmlFor="details" className="textarea_new_order">
                Details
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
